import type { Id } from "@repo/convex/dataModel";
import type { FrameworkEntityAliases } from "@repo/shared";
import { useMemo } from "react";
import { useOrganization } from "@/contexts/organization-context";
import { buildFrameworkEntityAliases } from "../lib/framework-registry";
import { useActiveOrgFrameworkStructure, useProjectFrameworkStructure } from "./useProjectData";

export function useFrameworkEntityAliases(
  projectId?: Id<"projects"> | null
): FrameworkEntityAliases | null {
  const { organizationId } = useOrganization();
  const projectStructure = useProjectFrameworkStructure(projectId ?? null);
  const orgStructure = useActiveOrgFrameworkStructure(projectId ? null : organizationId);
  const frameworkStructure = projectId ? projectStructure : orgStructure;

  return useMemo(() => {
    return buildFrameworkEntityAliases(frameworkStructure ?? null);
  }, [frameworkStructure]);
}
